var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React, { Component } from 'react';
import { Card, DropDownMenu, Tooltip } from '@philips-internal/oswald-ui-components/lib/components';
import { ReactComponent as MenuSVG } from '@philips-internal/oswald-ui-components/resources/assets/components/menu-context.svg';
import { SelectionType } from '@philips-internal/oswald-ui-constants';
import { AwesomeComponent, ComponentType } from '@philips-internal/oswald-ui-core';
import { eventListener, expression, oneOf, string } from '@philips-internal/oswald-ui-core/lib/component/prop-types';
import { ClickEvent } from '@philips-internal/oswald-ui-core/lib/component/types';
import { MessageService, ModelService } from '@philips-internal/oswald-ui-core/lib/services';
import { enumValues, generateUUID, isFunction, trigger } from '@philips-internal/oswald-ui-utils';
import { ReactComponent as CloudSVG } from '../../assets/images/icons/cloud.svg';
import { ReactComponent as CloudUploadSVG } from '../../assets/images/icons/cloud_upload.svg';
import { DATE_LOCALE } from '../../formatters/date-locale-formatter';
import ManualCardApi from './manual-card-api';
import { ManualCardClickAction, ManualCardType } from './manual-card-types';
import './manual-card.css';
let ManualCard = class ManualCard extends Component {
    constructor() {
        super(...arguments);
        this.onClickAction = (action) => {
            const { onClick } = this.props;
            if (isFunction(onClick)) {
                const value = {
                    action,
                    type: this.props.type,
                    id: this.props.id,
                    name: this.props.name,
                    size: this.props.size,
                    date: this.props.date,
                    path: this.props.path,
                };
                onClick(new ClickEvent({
                    value,
                }));
            }
        };
        this.onClickUpload = () => this.onClickAction(ManualCardClickAction.UPLOAD);
        this.onClickDownload = () => this.onClickAction(ManualCardClickAction.DOWNLOAD);
        this.onClickRemove = () => this.onClickAction(ManualCardClickAction.REMOVE);
        this.getDateFormatted = (input) => {
            if (!input) {
                return '';
            }
            return ModelService.format(DATE_LOCALE, input);
        };
    }
    static { this.propTypes = {
        onClick: eventListener,
        type: oneOf(enumValues(ManualCardType)),
        name: string,
        sizeExpression: expression,
        size: string,
        dateExpression: expression,
        date: string,
        uploadExpression: expression,
        downloadExpression: expression,
        deleteExpression: expression,
    }; }
    static { this.defaultProps = {
        type: ManualCardType.LOCAL,
    }; }
    renderAvatar() {
        const { type } = this.props;
        if (ManualCardType.LOCAL === type) {
            return (React.createElement(CloudUploadSVG, null));
        }
        return (React.createElement(CloudSVG, null));
    }
    renderAction() {
        const { type, uploadExpression, downloadExpression, deleteExpression } = this.props;
        if (ManualCardType.LOCAL === type) {
            return (React.createElement("div", { className: "c-manual-card__actions-menu-list" },
                React.createElement("span", { onClick: trigger(this.onClickUpload) }, MessageService.translate(uploadExpression))));
        }
        return (React.createElement("div", { className: "c-manual-card__actions-menu-list" },
            React.createElement("span", { onClick: trigger(this.onClickDownload) }, MessageService.translate(downloadExpression)),
            React.createElement("span", { onClick: trigger(this.onClickRemove) }, MessageService.translate(deleteExpression))));
    }
    renderContent() {
        const { name, sizeExpression, size, dateExpression, date } = this.props;
        return (React.createElement("div", { className: "c-manual-card__content" },
            React.createElement("div", { className: "c-manual-card__avatar" }, this.renderAvatar()),
            React.createElement("div", { className: "c-manual-card__data" },
                React.createElement(Tooltip, { value: name },
                    React.createElement("div", { className: "c-manual-card__prop_name" },
                        React.createElement("span", null, name))),
                React.createElement("div", { className: "c-manual-card__prop_data" },
                    React.createElement("span", null,
                        MessageService.translate(sizeExpression),
                        " ",
                        size)),
                React.createElement("div", { className: "c-manual-card__prop_data" },
                    React.createElement("span", null,
                        MessageService.translate(dateExpression),
                        " ",
                        this.getDateFormatted(date)))),
            React.createElement("div", { className: "c-manual-card__actions" },
                React.createElement(DropDownMenu, { uuid: generateUUID(), showArrow: false, showChevron: false },
                    React.createElement("div", { slot: "header" },
                        React.createElement(MenuSVG, null)),
                    React.createElement("div", { className: "c-manual-card__actions-menu", slot: "content" }, this.renderAction())))));
    }
    render() {
        return (React.createElement(Card, { className: "c-manual-card", selectionType: SelectionType.NONE, width: 12, uuid: "dc686797-8d45-4547-bea2-256c81221057" },
            React.createElement("div", { className: "c-manual-card__wrapper" }, this.renderContent())));
    }
};
ManualCard = __decorate([
    AwesomeComponent({ type: ComponentType.DATA_DISPLAY, api: ManualCardApi })
], ManualCard);
export default ManualCard;
//# sourceMappingURL=manual-card.js.map